<template>
	<div>
		<div class="detail-info">
			<h2 class="detail-info-name">
				{{ detail.name }}
			</h2>
			<h2 class="detail-info-name">
				{{ detail.unitName }}
			</h2>
			<h3 class="detail-info-brand">
				{{ detail.brandName }}
			</h3>
			<p class="detail-info-code ma-0">
				Código de producto: {{ detail.code }}
			</p>
		</div>
		<div class="price-box">
			{{ currency }}
			<span class="price-box-big">{{ priceWithoutDecimals }}</span>
			.{{ priceDecimals }}
		</div>
		<div class="columns">
			<div class="quantity-column">
				<quantity-config
					:quantity="detail.quantity"
					@add-quantity="$emit('add-quantity')"
					@change-value="$emit('change-value', $event)"
					@sub-quantity="$emit('sub-quantity')"
				></quantity-config>
			</div>
			<button class="add-btn">
				Agregar al carrito
			</button>
		</div>
	</div>
</template>

<script>
	import quantityConfig from '@/components/market-place/shared/quantity-config';

	function created() {
		const priceFixed = this.detail.price.toFixed(2);
		const priceItems = priceFixed.split('.');
		this.priceWithoutDecimals = priceItems[0];
		this.priceDecimals = priceItems[1];
	}

	function data() {
		return {
			priceWithoutDecimals: 0,
			priceDecimals: 0,
		};
	}

	export default {
		name: 'detail-info',
		components: {
			quantityConfig,
		},
		created,
		data,
		props: {
			currency: String,
			detail: {
				default: () => {},
				type: Object,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.detail-info {
		border-bottom: 1px solid rgba(216, 216, 216, 0.64);
		color: color(newwarning);
		margin-bottom: 33px;
		padding-bottom: 24px;
		text-align: center;

		@media (min-width: 936px) {
			margin-bottom: 53px;
			padding-bottom: 44px;
			text-align: left;
		}

		&-name {
			font-size: size(large25);
			font-weight: weight(regular);
			line-height: normal;

			@media (min-width: 936px) {
				font-size: size(large30);
			}
		}

		&-brand {
			font-size: size(large);
			font-weight: weight(black);
			margin: 10px 0px;
			text-transform: uppercase;

			@media (min-width: 936px) {
				font-size: size(large25);
				margin: 18px 0px;
			}
		}

		&-code {
			font-size: size(medium13);

			@media (min-width: 936px) {
				font-size: size(medium15);
			}
		}
	}

	.price-box {
		background-color: color(primary);
		border-radius: 5px;
		color: color(white);
		font-size: size(medium18);
		font-weight: weight(bold);
		height: 53px;
		line-height: 53px;
		margin-bottom: 19px;
		margin-left: auto;
		max-width: fit-content;
		max-width: -moz-fit-content;
		min-width: 134px;
		text-align: center;

		@media (min-width: 936px) {
			margin-bottom: 29px;
			margin-left: 0px;
		}

		&-big {
			font-size: size(large30);
		}
	}

	.quantity-column {
		display: inline-block;
		margin-right: 9px;
		vertical-align: middle;

		@media (min-width: 936px) {
			margin-right: 19px;
		}
	}

	.add-btn {
		background-color: transparent;
		border: 1px solid color(primary);
		border-radius: 5px;
		color: color(primary);
		display: inline-block;
		font-size: size(medium15);
		font-weight: weight(bold);
		height: 50px;
		vertical-align: middle;
		width: 147px;

		@media (min-width: 936px) {
			width: 177px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/product-detail/detail-info.vue